/* eslint-disable react/prop-types */
import React from 'react';
import { DataTypeProvider } from '@devexpress/dx-react-grid';
import { Table } from '@devexpress/dx-react-grid-material-ui';
import ReactSelect from 'react-select';

import TableCell from '@mui/material/TableCell';
import { styled } from '@mui/material/styles';
import { makeStyles } from '@material-ui/core';

import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';

const PREFIX = 'Demo';
const classes = {
  lookupEditCell: `${PREFIX}-lookupEditCell`,
  dialog: `${PREFIX}-dialog`,
  inputRoot: `${PREFIX}-inputRoot`,
  selectMenu: `${PREFIX}-selectMenu`
};
const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${classes.lookupEditCell}`]: {
    padding: theme.spacing(1)
  },
  [`& .${classes.dialog}`]: {
    width: 'calc(100% - 16px)'
  },
  [`& .${classes.inputRoot}`]: {
    width: '100%'
  },
  [`& .${classes.selectMenu}`]: {
    position: 'absolute !important'
  }
}));

const useStyles = makeStyles({
  root: {
    '& tfoot': {
      display: 'none'
    }
  }
});

// Starts inline editing on focus and displays validation errors for Customer fields.
export const CustomerFocusableCell = ({
  onClick,
  validationStatus = {},
  setValidationStatus = () => {},
  ...restProps
}) => {
  const { row, column } = restProps;
  const fieldStatus = validationStatus[row.id]?.[column.name];
  const isInvalid = fieldStatus?.isValid === false;

  const handleFocus = (event) => {
    // Focus bubbles from the lookup <select>. Starting editing again at that point
    // interrupts the select's change/blur commit lifecycle.
    if (event.currentTarget !== event.target) return;

    if (isInvalid) {
      setValidationStatus((previous) => ({
        ...previous,
        [row.id]: {
          ...previous[row.id],
          [column.name]: undefined
        }
      }));
    }
    onClick();
  };

  return (
    <Table.Cell
      {...restProps}
      tabIndex={0}
      onFocus={handleFocus}
      style={{
        ...restProps.style,
        border: isInvalid ? '1px solid red' : restProps.style?.border
      }}
      title={isInvalid ? fieldStatus.error : undefined}
    />
  );
};

const lookupOptions = {
  customerStatus: [
    { label: 'Enabled', value: 'Enabled' },
    { label: 'Disabled', value: 'Disabled' }
  ],
  Active: [
    { label: 'True', value: true },
    { label: 'False', value: false }
  ],
  Title: [
    { label: 'Mr', value: 'Mr' },
    { label: 'Mrs', value: 'Mrs' },
    { label: 'Miss', value: 'Miss' }
  ]
};

const CustomerLookupEditor = ({ column, value, onValueChange, onBlur, autoFocus }) => {
  const classes = useStyles();
  const options = lookupOptions[column.name] || [];

  const theme = useTheme();
  const isSmall = useMediaQuery(theme.breakpoints.down('sm'));
  const columnName = column.name;

  const dropdownValue = { value, label: value };

  const handleChange = (selectedOption) => {
    onValueChange(selectedOption.value);
  };

  return (
    <>
      <StyledTableCell className={classes.lookupEditCell}>
        <ReactSelect
          onBlur={isSmall ? null : onBlur} //blur doesn't work in mobile phones
          autoFocus={autoFocus}
          className="basic-single"
          classNamePrefix="select"
          defaultValue={dropdownValue}
          isSearchable={true}
          name="color"
          options={options}
          //   isClearable={true}
          // eslint-disable-next-line no-undef
          menuPortalTarget={document.body}
          styles={{ menuPortal: (base) => ({ ...base, zIndex: 9999 }) }}
          onChange={(selectedOption) => {
            if (selectedOption === null) {
              // Handle the case when the selected option is cleared
              handleChange(null);
            } else {
              if (columnName === 'customerStatus' || columnName === 'Active' || columnName === 'Title') {
                handleChange({ name: selectedOption.value, value: selectedOption.value });
              } else {
                handleChange(selectedOption.value);
              }
            }
          }}
        />
      </StyledTableCell>
    </>
  );
};

export const CustomerLookupProvider = (props) => <DataTypeProvider editorComponent={CustomerLookupEditor} {...props} />;
